import { ILocations, ILocationsCompany } from './../../utils/interface/location';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetLocations, handleGetLocationsCompany } from './locationThunk';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

export interface locationState {
  locations: ILocations;
  locationCompany: ILocationsCompany;
  filter: ILocationCompanyFilter;
  needRefreshData: boolean;
  currentPage: number;
  totalPages: number;
  selectedIds: Array<string>;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface ILocationCompanyFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: locationState = {
  locations: [],
  locationCompany: [],
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  selectedIds: [],
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<ILocationCompanyFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetLocations.pending, (_state, _action) => {})
      .addCase(handleGetLocations.fulfilled, (state, action) => {
        state.locations = [...action.payload.responses];
      })
      .addCase(handleGetLocations.rejected, (_state, _action) => {})
      .addCase(handleGetLocationsCompany.fulfilled, (state, action) => {
        state.locationCompany = [...action.payload.responses];
        state.needRefreshData = false;
        state.totalPages = action.payload.pagination.totalPages;
      });
  },
});

export const locationActions = locationSlice.actions;

const locationReducer = locationSlice.reducer;
export default locationReducer;
